import React from 'react';

function TaskCalendar({ color = 'black', bgColor = 'white' }) {
  return (
    <>
      <svg width="34" height="34" viewBox="0 0 24 25" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
        <path d="M16 2.5V6.5M8 2.5V6.5" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M13 4.5H11C7.22876 4.5 5.34315 4.5 4.17157 5.67157C3 6.84315 3 8.72876 3 12.5V14.5C3 18.2712 3 20.1569 4.17157 21.3284C5.34315 22.5 7.22876 22.5 11 22.5H13C16.7712 22.5 18.6569 22.5 19.8284 21.3284C21 20.1569 21 18.2712 21 14.5V12.5C21 8.72876 21 6.84315 19.8284 5.67157C18.6569 4.5 16.7712 4.5 13 4.5Z" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3 10.5H21" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M11.9955 14.5H12.0045M11.9955 18.5H12.0045M15.991 14.5H16M8 14.5H8.00897M8 18.5H8.00897" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      </svg>

    </>
  );
}

export default TaskCalendar;
